import { IGetters } from '@/models/store/getters.interface';
import { Routes } from '@/models/router/router.interface';
import campaignPresenter from '@/presenters/campaign-presenter';
import state from './state';

const getters: IGetters = {
	accountManager: () => {
		return state.accountManager;
	},
	allAccountManagers: () => {
		return state.allAccountManagers;
	},
	allClientServicesPeople: () => {
		return state.allClientServicesPeople;
	},
	allPricingProducts: () => {
		return state.allPricingProducts;
	},
	auditorEntries: () => {
		return state.auditorEntries;
	},
	availableEntities: () => {
		return state.availableEntities;
	},
	budgetCustom: () => {
		return state.budgetCustom;
	},
	budgetListing: () => {
		return state.budgetListing;
	},
	budgetTotal: () => {
		return state.budgetTotal;
	},
	campaignLiftExcluded: () => {
		return state.campaignLiftExcluded;
	},
	campaignReadinessInfo: () => {
		return state.campaignReadinessInfo;
	},
	campaignType: () => {
		return state.campaignType;
	},
	clientServicesPerson: () => {
		return state.clientServicesPerson;
	},
	crmId: () => {
		return state.crmId;
	},
	currency: () => {
		return state.currency;
	},
	customProducts: () => {
		return state.customProducts;
	},
	deliveryMode: () => {
		return state.deliveryMode;
	},
	duplicateEntryCampaignDetails: () => {
		return state.duplicateEntryCampaignDetails;
	},
	endDate: () => {
		return state.endDate;
	},
	entitiesAffectedByUnlinking: () => {
		return state.entitiesAffectedByUnlinking;
	},
	entitySearchQuery: () => {
		return state.entitySearchQuery;
	},
	entitySearchQueryItems: () => {
		const searchQuery = state.entitySearchQuery.toLowerCase();
		return searchQuery
			.split(',')
			.map((item) => item.trim())
			.filter((item) => item.length);
	},
	filteredEntities: () => {
		const entitySearchQueryItems =  getters.entitySearchQueryItems();
		if (!entitySearchQueryItems.length) {
			return state.availableEntities;
		}

		const result = state.availableEntities.filter((entity) => {
			return entitySearchQueryItems.find((item) =>
				entity.name.toLowerCase().includes(item) || entity.id.toString() === item
			);
		});

		return result;
	},
	idsOfModifiedCustomProducts: () => {
		return state.idsOfModifiedCustomProducts;
	},
	internalNotes: () => {
		return state.internalNotes;
	},
	invalidCampaignPropertyDetails: () => {
		return state.invalidCampaignPropertyDetails;
	},
	isCampaignCreation: () => {
		return state.router.props.isCampaignCreation;
	},
	isGeotargetingMicroserviceReady: () => {
		return state.isGeotargetingMicroserviceReady;
	},
	isSaveEnabled: () => {
		const routesWhichHaveSavingEnabled = [
			Routes.GENERAL,
			Routes.LINKED_ORGANISATIONS,
			Routes.ENTITIES_AND_GEOTARGETING,
			Routes.CUSTOM_PRODUCTS,
			Routes.RIGHTS,
			Routes.INTERNAL_NOTES
		];

		if (!routesWhichHaveSavingEnabled.includes(state.router.current)) {
			return false;
		}

		return campaignPresenter.hasCampaignDataChanged();
	},
	linkedOrganisations: () => {
		return state.linkedOrganisations;
	},
	loadCount: () => {
		return state.loadCount;
	},
	loadingStatusAccountManagers: () => {
		return state.loadingStatusAccountManagers;
	},
	loadingStatusAuditorEntries: () => {
		return state.loadingStatusAuditorEntries;
	},
	loadingStatusCampaignReadinessInfo: () => {
		return state.loadingStatusCampaignReadinessInfo;
	},
	loadingStatusClientServicesPeople: () => {
		return state.loadingStatusClientServicesPeople;
	},
	loadingStatusCustomProducts: () => {
		return state.loadingStatusCustomProducts;
	},
	loadingStatusEntities: () => {
		return state.loadingStatusEntities;
	},
	loadingStatusPricingProducts: () => {
		return state.loadingStatusPricingProducts;
	},
	loadingStatusPrimaryData: () => {
		return state.loadingStatusPrimaryData;
	},
	loadingStatusRights: () => {
		return state.loadingStatusRights;
	},
	modalCustomProductState: () => {
		return state.modalCustomProductState;
	},
	modalErrorState: () => {
		return state.modalErrorState;
	},
	modalUnsafeExitState: () => {
		return state.modalUnsafeExitState;
	},
	name: () => {
		return state.name;
	},
	notificationStatus: () => {
		return state.notificationStatus;
	},
	originalCampaignData: () => {
		return state.originalCampaignData;
	},
	overlappingCampaignsCluster: () => {
		return state.overlappingCampaignsCluster;
	},
	partnershipType: () => {
		return state.partnershipType;
	},
	persistGLParamRefLink: () => {
		return state.persistGLParamRefLink;
	},
	region: () => {
		return state.region;
	},
	rightsUsers: () => {
		return state.rightsUsers;
	},
	router: () => {
		return state.router;
	},
	selectedCustomProductId: () => {
		return state.selectedCustomProductId;
	},
	selectedTypeForCustomProductCreation: () => {
		return state.selectedTypeForCustomProductCreation;
	},
	selectedTableActionsDropdown: () => {
		return state.selectedTableActionsDropdown;
	},
	standAloneLogin: () => {
		return state.standAloneLogin;
	},
	startDate: () => {
		return state.startDate;
	},
	validationInfoDates: () => {
		return state.validationInfoDates;
	},
	validationResult: () => {
		return state.validationResult;
	}
};

export default getters;
